var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { types } from './';
import { container } from 'tsyringe';
import { JobStatus } from 'packages/v3/jobs/Job';
import { JobSummaryRepository } from 'packages/v4/jobs/JobSummaryRepository';
import { FormInitializer } from 'services/form/FormInitializer';
import { EntityBuilder } from '@decahedron/entity';
import { Form as V2Form } from 'packages/form/entities/Form';
import { Form, FormTypes } from 'packages/form/entities/legacy/Form';
import moment from 'moment';
import { TargetRepository } from 'packages/jobs/TargetRepository';
import { StarredRecruitmentsRepository } from 'packages/jobs/StarredRecruitmentsRepository';
import { JobRepository as V3JobRepository } from 'packages/v3/jobs/JobRepository';
import { JobRepository as V5JobRepository } from 'packages/v5/jobs/JobRepository';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import { FormRepository } from 'packages/form/FormRepository';
import VueI18n from 'vue-i18n';
import { QuestionBuilder } from 'services/form/QuestionBuilder';
import { retrievePrototype } from 'common/prototypes/forms/BlockPrototypes';
import ResultsManager from 'packages/form/legacy/ResultsManager';
import isNil from 'common/support/isNil';
var searchPromise = null;
var favJobsSearchPromise = null;
var formRepository = container.resolve(FormRepository);
export var actions = {
    toggleAllCandidateResultScreenFilters: function (_a) {
        var commit = _a.commit, getters = _a.getters;
        var filters = (getters.resultScreens('').length)
            ? getters.resultScreens('').map(function (filter) { return filter.identifier; })
            : [];
        commit(types.SET_RESULT_SCREEN_FILTERS, filters);
    },
    getJobWithStages: function (_a, jobId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var job;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        return [4 /*yield*/, (container.resolve(V5JobRepository)).getJobWithStages(jobId)];
                    case 1:
                        job = _b.sent();
                        job.stages = job.stages.sort(function (a, b) { return a.position - b.position; });
                        commit(types.SET_JOB, job);
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getJobsWithStats: function (_a, _b) {
        var commit = _a.commit;
        var companyId = _b.companyId, query = _b.query;
        return __awaiter(this, void 0, void 0, function () {
            var repo;
            return __generator(this, function (_c) {
                repo = container.resolve(JobSummaryRepository);
                commit(types.SET_LOADING, true);
                if (searchPromise) {
                    searchPromise.cancel();
                }
                searchPromise = repo.allWithStats(companyId, query);
                return [2 /*return*/, searchPromise.then(function (result) {
                        commit(types.SET_PAGINATION, result.pagination);
                        commit(types.SET_JOBS, result.items);
                        searchPromise = null;
                        commit(types.SET_LOADING, false);
                    })];
            });
        });
    },
    getStarredJobsWithStats: function (_a, _b) {
        var commit = _a.commit;
        var companyId = _b.companyId, query = _b.query;
        return __awaiter(this, void 0, void 0, function () {
            var repo;
            return __generator(this, function (_c) {
                repo = container.resolve(JobSummaryRepository);
                query.setFilter('starred', 1);
                if (favJobsSearchPromise) {
                    favJobsSearchPromise.cancel();
                }
                favJobsSearchPromise = repo.allWithStats(companyId, query);
                return [2 /*return*/, favJobsSearchPromise.then(function (result) {
                        commit(types.SET_STARRED_JOBS, result.items);
                        favJobsSearchPromise = null;
                    })];
            });
        });
    },
    createNewJob: function (_a, job) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        _b = commit;
                        _c = [types.SET_JOB];
                        return [4 /*yield*/, container.resolve(V5JobRepository).createJob(job)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    createJobWithDefaultConfig: function (_a, payload) {
        var _b, _c, _d, _e, _f, _g, _h, _j;
        var commit = _a.commit, dispatch = _a.dispatch, rootState = _a.rootState;
        return __awaiter(this, void 0, void 0, function () {
            var auth, formRepo, i18n, resultsManager, language, newJob, jobForm, coverLetterQuestion, form, landingPage;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        auth = container.resolve(Authenticator);
                        formRepo = container.resolve(FormRepository);
                        i18n = container.resolve(VueI18n);
                        resultsManager = container.resolve(ResultsManager);
                        language = payload.formTemplate ? payload.formTemplate.lang : (_e = (_d = (_c = (_b = rootState.jobLists) === null || _b === void 0 ? void 0 : _b.jobLists) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.locale) !== null && _e !== void 0 ? _e : 'fi-FI';
                        return [4 /*yield*/, dispatch('jobLists/listForCompany', (_f = payload.companyId) !== null && _f !== void 0 ? _f : auth.getSelectedCompany(), { root: true })];
                    case 1:
                        _k.sent();
                        payload.job.companyId = (_g = payload.companyId) !== null && _g !== void 0 ? _g : auth.getSelectedCompany();
                        payload.job.activeFrom = moment().format('YYYY-MM-DD');
                        payload.job.status = JobStatus.DRAFT;
                        return [4 /*yield*/, container.resolve(V5JobRepository).createJob(payload.job)];
                    case 2:
                        newJob = _k.sent();
                        return [4 /*yield*/, FormInitializer.initializeFormFromTemplate(EntityBuilder.buildOne(payload.job.version === 2 ? V2Form : Form, payload.formTemplate.toJson()))];
                    case 3:
                        jobForm = _k.sent();
                        jobForm.uuid = null;
                        if (payload.job.version === 2) {
                            jobForm.lang = language;
                            jobForm.ensureResultScreens();
                        }
                        // if the form template UUID is null, it's the default template
                        if (payload.formTemplate.uuid === null) {
                            coverLetterQuestion = QuestionBuilder.fromBlockPrototype(retrievePrototype('open_text'));
                            coverLetterQuestion.label = i18n.t('ats.job.application_form.questions.cover_letter');
                            coverLetterQuestion.position = jobForm.questions.length + 1;
                            jobForm.questions.push(coverLetterQuestion);
                            jobForm.results[0].title = i18n.t('ats.job.application_form.results.title');
                            jobForm.results[0].description = i18n.t('ats.job.application_form.results.description');
                            jobForm.type = FormTypes.APPLICATION;
                        }
                        jobForm.companyId = (_h = payload.companyId) !== null && _h !== void 0 ? _h : auth.getSelectedCompany();
                        jobForm.type = FormTypes.APPLICATION;
                        jobForm.name = payload.job.name;
                        jobForm.lang = language;
                        jobForm.jobId = newJob.id;
                        if (payload.job.version !== 2) {
                            jobForm.results = resultsManager.recalculateIdentifiers(jobForm.results);
                            jobForm.results = resultsManager.recalculateScoreThresholds(jobForm.results);
                        }
                        return [4 /*yield*/, formRepo.createForm(jobForm)];
                    case 4:
                        form = _k.sent();
                        return [4 /*yield*/, dispatch('landingPages/createDefaultLandingPage', {
                                job: newJob,
                                delta: payload.delta,
                                form: form,
                                branding: payload.branding,
                                companyId: (_j = payload.companyId) !== null && _j !== void 0 ? _j : auth.getSelectedCompany(),
                            }, { root: true })];
                    case 5:
                        landingPage = _k.sent();
                        commit(types.SET_JOB, newJob);
                        return [4 /*yield*/, dispatch('landingPages/linkJobLists', {
                                landingPageId: landingPage.id,
                                jobId: newJob.id,
                                jobLists: rootState.jobLists.jobLists,
                            }, { root: true })];
                    case 6:
                        _k.sent();
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/, { job: newJob, form: form, landingPage: landingPage }];
                }
            });
        });
    },
    getTargetUrl: function (_a, jobId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = commit;
                        _c = [types.SET_TARGET_URL];
                        return [4 /*yield*/, container.resolve(TargetRepository).getWidgetUrl(jobId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    },
    updateStages: function (_a, stages) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var job, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        job = state.job;
                        _b = job;
                        return [4 /*yield*/, container.resolve(V3JobRepository).updateStages(job.id, stages)];
                    case 1:
                        _b.stages = _c.sent();
                        commit(types.SET_JOB, job);
                        return [2 /*return*/];
                }
            });
        });
    },
    updateJob: function (_a, job) {
        var commit = _a.commit, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var applicationForm;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, container.resolve(V5JobRepository).updateJob(job)];
                    case 1:
                        _b.sent();
                        applicationForm = getters['currentJob/applicationForm'];
                        if (!!isNil(applicationForm)) return [3 /*break*/, 3];
                        return [4 /*yield*/, formRepository.revalidateCachedForm(applicationForm.uuid)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        commit(types.SET_JOB, job);
                        return [2 /*return*/];
                }
            });
        });
    },
    getCandidatesForJob: function (_a, jobId) {
        var commit = _a.commit, state = _a.state, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, container.resolve(V3JobRepository).getCandidatesForJob(jobId)];
                    case 1:
                        items = (_b.sent()).items;
                        commit(types.SET_CANDIDATES, items);
                        dispatch('toggleAllCandidateResultScreenFilters');
                        return [2 /*return*/];
                }
            });
        });
    },
    removeCandidatesFromPipeline: function (_a, candidates) {
        var commit = _a.commit, state = _a.state, rootState = _a.rootState;
        return __awaiter(this, void 0, void 0, function () {
            var repo, candidatesList;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        repo = (new V3JobRepository());
                        candidatesList = rootState.jobs.candidates.slice();
                        return [4 /*yield*/, repo.removeCandidatesFromPipeline(candidates)];
                    case 1:
                        _b.sent();
                        candidates.forEach(function (candidate) {
                            candidatesList.splice(candidatesList.findIndex(function (c) { return c.id === candidate.id; }), 1);
                        });
                        commit('jobs/setCandidates', candidatesList, { root: true });
                        return [2 /*return*/];
                }
            });
        });
    },
    updateJobStatus: function (_a, payload) {
        var commit = _a.commit, state = _a.state, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var job, applicationForm, newJob;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        job = state.job;
                        applicationForm = getters['currentJob/applicationForm'];
                        job.status = payload.status;
                        return [4 /*yield*/, container.resolve(V5JobRepository).updateJobStatus(job.id, payload.status, payload.expiryDate)];
                    case 1:
                        newJob = _b.sent();
                        if (!!isNil(applicationForm)) return [3 /*break*/, 3];
                        return [4 /*yield*/, formRepository.revalidateCachedForm(applicationForm.uuid)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        commit(types.SET_JOB, newJob);
                        return [2 /*return*/];
                }
            });
        });
    },
    archiveJob: function (_a, jobId) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = commit;
                        _c = [types.SET_JOB];
                        return [4 /*yield*/, container.resolve(V5JobRepository).archiveJob(jobId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    },
    unarchiveJob: function (_a, jobId) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = commit;
                        _c = [types.SET_JOB];
                        return [4 /*yield*/, container.resolve(V5JobRepository).unarchiveJob(jobId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    },
    moveCandidates: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var stageId = _b.stageId, candidateIds = _b.candidateIds;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        candidateIds.forEach(function (id) {
                            var candidate = state.candidates.find(function (candidate) { return candidate.id === id; });
                            candidate.pipelineStage = stageId;
                            commit(types.UPDATE_CANDIDATE, candidate);
                        });
                        return [4 /*yield*/, container.resolve(V3JobRepository).bulkMoveInJob(state.job.id, candidateIds, stageId)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    favouriteJob: function (_a, jobId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var starRepo, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        starRepo = container.resolve(StarredRecruitmentsRepository);
                        commit(types.SET_JOB_AS_STARRED, jobId);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, starRepo.addFavourite(jobId)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        commit(types.UNSET_JOB_AS_STARRED, jobId);
                        throw new Error(e_1);
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    unfavouriteJob: function (_a, jobId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var starRepo, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        starRepo = container.resolve(StarredRecruitmentsRepository);
                        commit(types.UNSET_JOB_AS_STARRED, jobId);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, starRepo.deleteFavourite(jobId)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        commit(types.SET_JOB_AS_STARRED, jobId);
                        throw new Error(e_2);
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
};
